import { createActor, canisterId } from "./declarations/backend"
import { queryReady } from "./query_ready.js"

const STUBBED = " (stubbed, no canister)"

// The text a canister refusal carries: the message is wrapped in replica
// boilerplate, but the reason follows "refused: " and ends at the closing quote.
export const refusalReason = (err) => String(err?.message ?? err).match(/refused: ([^'\n]*)/)?.[1] ?? null

const summarise = (text) => text.length > 80 ? `${text.slice(0, 40)}…${text.slice(-24)} (${text.length} characters)` : text

// Runs one button of a Feature Panel. A port compares the reply with its
// expected text (a refusal for `data-refusal`); a stateful one appends to a call
// log instead, because its state is shared and moves on with every call; a
// showcase has nothing to compare and just shows the reply. Under the dev stub
// there is no canister, so a port shows its expected text, labelled as stubbed
// (ADR-0001, extended), and a showcase calls the stub's canned answer.
export const runPanel = async (panel, method, actor, stubbed) => {
  const expected = panel.dataset.expected
  const log = panel.querySelector(".feature-log")
  const out = log ? document.createElement("li") : panel.querySelector(".feature-result")
  if (log) log.append(out)
  const buttons = [...panel.querySelectorAll(".feature-run")]
  // Only the first button is the challenge itself (and may be the refusal);
  // any other, like trap_text_bound's `read`, just shows its reply.
  const primary = buttons.length === 0 || buttons[0].dataset.method === method
  const label = log && buttons.length > 1 ? `${buttons.find((b) => b.dataset.method === method)?.textContent ?? method}: ` : ""

  if (stubbed && expected !== undefined && primary) {
    out.textContent = `${label}${expected.split("\n")[0]}${STUBBED}`
    return
  }
  out.textContent = "Running…"
  try {
    const reply = await actor[method]()
    if (primary && panel.dataset.refusal) {
      out.textContent = `✗ ${summarise(String(reply))}: expected a refusal`
    } else if (expected === undefined || log || !primary) {
      out.textContent = `${label}${reply}${stubbed ? STUBBED : ""}`
    } else {
      out.textContent = `${reply} ${reply === expected ? "✓ matches expected" : "✗ differs from expected"}`
    }
  } catch (err) {
    const reason = refusalReason(err)
    if (primary && panel.dataset.refusal && reason !== null) {
      out.textContent = `${reason === expected ? "✓" : "✗"} refused: ${summarise(reason)}${reason === expected ? " (matches expected)" : " (differs from expected)"}`
    } else if (reason !== null) {
      out.textContent = `${label}refused: ${reason}`
    } else {
      out.textContent = `Failed: ${err.message || err}`
    }
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const panels = [...document.querySelectorAll(".feature-panel")].filter((p) => p.querySelector(".feature-run"))
  if (!panels.length) return

  const stubbed = canisterId === "dev-stub"
  const actor = canisterId ? createActor(canisterId) : null

  panels.forEach((panel) => {
    panel.querySelectorAll(".feature-run").forEach((button) => {
      button.addEventListener("click", async () => {
        if (!canisterId) {
          (panel.querySelector(".feature-result") ?? panel).textContent = "No backend canister id: deploy first."
          return
        }
        const ready = stubbed ? actor : await queryReady(actor)
        // A "×10" button repeats the call, one after another, each logged.
        for (let i = 0; i < Number(button.dataset.repeat || 1); i += 1) {
          await runPanel(panel, button.dataset.method, ready, stubbed)
        }
      })
    })
  })
})
